import { PresentationTiming } from '../../common/presentation-timing';

export interface IPresentationModel {
    id: string;
    timing: PresentationTiming;
    duration?: number;
    firmTimeDuration?: number;
    presenterDefinedDuration?: number;
    actualDuration?: number;
    endTime?: number;
    title: string;
    content: string;
    inProgress: boolean;
    currentSection: string | undefined;
    sectionStartTime?: number;
    isDemo: boolean;
    creationDate: number;
    lastModifiedDate: number;
}


export class PresentationModel implements IPresentationModel {
    public id: string = '';
    public timing: PresentationTiming = PresentationTiming.None;
    public duration?: number = undefined;
    public firmTimeDuration?: number = undefined;
    public presenterDefinedDuration?: number = undefined;
    public actualDuration?: number = undefined;
    public endTime?: number = undefined;
    public title: string = '';
    public content: string = '';
    public inProgress: boolean = false;
    public currentSection: string | undefined = undefined;
    public sectionStartTime?: number = undefined;
    public isDemo: boolean = false;
    public creationDate: number = 0;
    public lastModifiedDate: number = 0;
}


